<template>
  <v-container>
    <v-container class="text-center mt-5 mb-3">
      <v-avatar color="warning" size="100px">
      <v-img v-if="user.profilePicture && user.profilePicture.trim() !== ''" :src="user.profilePicture" />
        <span v-else class="user-initials--text" style="font-size: 3rem">{{ initials }}</span>
      </v-avatar>
      <v-container>
        <strong>{{ user.firstName }} {{ user.lastName }}</strong
        ><br />
        <small class="grey--text">{{ user.email.toLowerCase() }}</small>
      </v-container>
    </v-container>
    <v-list flat>
      <v-list-item-group color="primary">
        <v-list-item :to="{ name: 'AccountSettings' }">
            <v-list-item-title>Kontoeinstellungen</v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
        </v-list-item>

        <v-list-item v-if="isLocationManager" :to="{ name: 'LocationSettings' }">
            <v-list-item-title>Standortverwaltung</v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
        </v-list-item>

        <v-list-item v-if="isUserManager" :to="{ name: 'UserList' }">
            <v-list-item-title>Benutzerverwaltung</v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
        </v-list-item>

        <v-list-item :to="{ name: 'Privacy' }">
            <v-list-item-title>Datenschutz</v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
        </v-list-item>

        <v-list-item :to="{ name: 'Imprint' }">
            <v-list-item-title>Impressum</v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
        </v-list-item>

        <v-list-item class="logout-list-item" @click="logout">
            <v-list-item-title>Abmelden</v-list-item-title>
            <v-list-item-icon>
              <v-icon class="logout-icon">mdi-logout</v-icon>
            </v-list-item-icon>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      isUserManager: "userIsUserManager",
      isLocationManager: "userIsLocationManager",
      user: "user",
    }),
    initials() {
      return (
        this.$store.getters.user.firstName[0] +
        this.$store.getters.user.lastName[0]
      );
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="sass" scoped>
.v-list-item--link
  color: #385f73 !important

.v-list-item
  border-bottom: 1px solid #ddd
.v-list-item:first-child
  border-top: 1px solid #ddd
.v-list-item:last-child
  border-bottom: none

.v-icon
  color: rgba(0, 0, 0, 0.54) !important
.theme--light.v-list-item.logout-list-item
  color: $primary !important
.logout-icon
  color: $primary !important

.v-avatar
  border: 1px solid #ddd !important
.user-initials--text 
  color: #9CE9C2 !important
</style>
